// ----------------------------------------------------------------------------
// Component: Hero Banner Slider
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, A11y, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import 'swiper/css/autoplay';
// Scripts
import '../../snippets/background-media/background-media';

// Styles
import './_hero-banner--slider.scss';

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    
    var swiper = new Swiper(".hero-banner-slider", {
        modules: [Navigation, Pagination, Autoplay, A11y],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
        preloadImages: true,
        updateOnImagesReady: true,
        on: {
            init: function () {
                $( ".hero-banner-slider" ).removeClass( "preload-banner" );
            },
        },
        navigation: {
            nextEl: ".hero-banner-slider .swiper-arrow.swiper-button-next",
            prevEl: ".hero-banner-slider .swiper-arrow.swiper-button-prev",
        },
        pagination: {
            el: ".hero-banner-slider .swiper-pagination",
            clickable: true
        },
        autoplay: {
            disableOnInteraction: true,
            delay: 5000
        }
    });   
      
    /*In case we need a progress bar in the slider
    var progressBar = document.querySelector(".hero-banner-slider .progress");
    progressBar.addEventListener("animationend", myEndFunction);

    // Retrigger Animation on Slide Change
    function myEndFunction() {
        swiper.slideNext();
        progressBar.style.animation = "none";
        void progressBar.offsetWidth;
        progressBar.style.animation = null;
    }

    // Reset Progress Bar On Slide Change
    swiper.on("slideChange", function () {
        progressBar.style.animation = "none";
        void progressBar.offsetWidth; 
        progressBar.style.animation = null;
        progressBar.style.animationPlayState = "paused";
    });

    //Resumes Progress Bar Animation when mouse leaves slider
    document.querySelectorAll(".hero-banner-slider").forEach((item) => {
        item.addEventListener("mouseleave", function () {
            progressBar.style.animationPlayState = "running";
        });
    });
       
    //Pauses Progress Bar Animation when mouse enters slider
    document.querySelectorAll(".hero-banner-slider").forEach((item) => {
        item.addEventListener("mouseenter", function () {
            progressBar.style.animationPlayState = "paused";
        });
    });
    */
});
